/* eslint-disable no-unused-vars */
import { useEffect } from 'react'

export enum AppBgColors {
  GRAY = 'gray',
  GREY = 'grey',
}

const BG_COLOR_CLASSES = {
  gray: 'type_gray_bg',
  grey: 'type_gray_bg',
}

const useAppBgColor = (color: AppBgColors): void => {
  useEffect(() => {
    const wrapper = document.body

    if (wrapper && color) {
      wrapper.classList.add(BG_COLOR_CLASSES[color])
    }

    return () => {
      if (wrapper && color) {
        wrapper.classList.remove(BG_COLOR_CLASSES[color])
      }
    }
  }, [color])
}

export default useAppBgColor
